import { common } from '@ocean/ui'
import { Wrapper } from './InfoListValue.styled'

const { Typography } = common

const InfoListValue: React.FC = ({ children }) => {
  return (
    <Wrapper data-test='InfoListValue'>
      <Typography variant='p'>{children}</Typography>
    </Wrapper>
  )
}

export default InfoListValue
